module.exports = __webpack_public_path__ + "static/media/U1-T2-1-1c.9d17f80e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/U1-T2-1-1c.mp3
// module id = 503
// module chunks = 0